import { useQueries, UseQueryOptions, UseQueryResult, QueryKey } from '@tanstack/react-query'
import { ApiResult } from '../types'
import { queryFnWithApiResult } from '../utils'

type UsePortalQueriesItemOptions<TData, TSelect = TData | null, TQueryKey extends QueryKey = QueryKey> = Omit<
  UseQueryOptions<TData | null, Error, TSelect, TQueryKey>,
  'queryFn'
> & {
  queryFn: () => Promise<ApiResult<TData> | TData>
}

/**
 * A wrapper around react-query's useQueries that automatically handles ApiResult unwrapping.
 * Each queryFn should return a Promise<ApiResult<T>> or a plain Promise<T>.
 */
const usePortalQueries = <TData, TSelect = TData | null, TQueryKey extends QueryKey = QueryKey>(
  queries: UsePortalQueriesItemOptions<TData, TSelect, TQueryKey>[]
): UseQueryResult<TSelect, Error>[] => {
  return useQueries({
    queries: queries.map(({ queryFn, ...rest }) => ({
      ...rest,
      queryFn: queryFnWithApiResult(queryFn),
    })),
  }) as UseQueryResult<TSelect, Error>[]
}

export default usePortalQueries
